import { render, staticRenderFns } from "./SafetyHseList.vue?vue&type=template&id=5aa22fba&scoped=true"
import script from "./SafetyHseList.vue?vue&type=script&lang=js"
export * from "./SafetyHseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa22fba",
  null
  
)

export default component.exports